/* La Sala — prenotazione dell'olio nuovo.
 *
 * Raccoglie quanti pezzi di ogni formato vuole il cliente e li manda al carrello
 * come PROPRIETÀ della riga d'ordine del prodotto «PRENOTAZIONE OLIO NUOVO».
 * Così la scelta viaggia dentro l'ordine: niente moduli a parte da riconciliare
 * a mano con chi ha pagato i 5 €.
 *
 * ⚠️ Prima di aggiungere, toglie dal carrello le righe di prenotazione già
 * presenti: properties diverse creano righe diverse, e senza questa pulizia
 * due tentativi di fila facevano pagare 10 € con due liste discordi.
 */
(function () {
  var sez = document.querySelector('.lsprenota');
  if (!sez) return;

  var campi = [].slice.call(sez.querySelectorAll('.lsprenota__n'));
  var cta = sez.querySelector('.lsprenota__cta');
  var ris = sez.querySelector('.lsprenota__riepilogo');
  var varianteId = parseInt(sez.getAttribute('data-variante'), 10);
  if (!campi.length || !cta || !varianteId) return;

  var euro = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
  var vuoto = ris ? ris.getAttribute('data-vuoto') || '' : '';
  var pieno = ris ? ris.getAttribute('data-pieno') || '' : '';

  function passoDi(campo) {
    return parseInt(campo.getAttribute('data-passo'), 10) || 1;
  }

  /* Un numero scritto a mano va riportato sul passo del prodotto: con le
     bomboniere (minimo 25) un «7» digitato non è un ordine possibile. */
  function normalizza(campo) {
    var passo = passoDi(campo);
    var n = parseInt(campo.value, 10);
    if (isNaN(n) || n <= 0) return 0;
    if (n < passo) return n < passo / 2 ? 0 : passo;
    return Math.round(n / passo) * passo;
  }

  function scelte() {
    var out = [];
    campi.forEach(function (c) {
      var n = parseInt(c.value, 10) || 0;
      if (n > 0) {
        out.push({
          nome: c.getAttribute('data-nome'),
          n: n,
          cent: (parseInt(c.getAttribute('data-prezzo'), 10) || 0) * n
        });
      }
    });
    return out;
  }

  function aggiorna() {
    var s = scelte();
    var pezzi = 0, cent = 0;
    s.forEach(function (x) { pezzi += x.n; cent += x.cent; });

    campi.forEach(function (c) {
      var card = c.closest('.lsprenota__card');
      if (card) card.classList.toggle('is-scelto', (parseInt(c.value, 10) || 0) > 0);
    });

    cta.disabled = s.length === 0;

    if (!ris) return;
    if (s.length === 0) {
      ris.textContent = vuoto;
    } else {
      ris.innerHTML = pieno
        .replace('{totale}', '<strong>' + euro.format(cent / 100) + '</strong>')
        .replace('{pezzi}', pezzi)
        .replace('{formati}', s.length);
    }
  }

  campi.forEach(function (c) {
    var card = c.closest('.lsprenota__card');
    if (!card) return;
    var meno = card.querySelector('.lsprenota__meno');
    var piu = card.querySelector('.lsprenota__piu');
    var passo = passoDi(c);

    if (piu) piu.addEventListener('click', function () {
      c.value = (parseInt(c.value, 10) || 0) + passo;
      aggiorna();
    });
    if (meno) meno.addEventListener('click', function () {
      c.value = Math.max(0, (parseInt(c.value, 10) || 0) - passo);
      aggiorna();
    });
    c.addEventListener('input', aggiorna);
    c.addEventListener('blur', function () { c.value = normalizza(c); aggiorna(); });
  });

  function svuotaPrenotazioni() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrello) {
        var da = [];
        (carrello.items || []).forEach(function (it, i) {
          if (it.variant_id === varianteId) da.push(i + 1);
        });
        // dall'ultima alla prima: togliendo una riga gli indici successivi scalano
        return da.reverse().reduce(function (catena, linea) {
          return catena.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ line: linea, quantity: 0 })
            });
          });
        }, Promise.resolve());
      })
      .catch(function () { /* se il carrello non risponde si prosegue lo stesso */ });
  }

  cta.addEventListener('click', function () {
    var s = scelte();
    if (!s.length || cta.disabled) return;

    var props = {};
    var cent = 0;
    s.forEach(function (x) {
      props[x.nome] = String(x.n);
      cent += x.cent;
    });
    props['Totale olio prenotato'] = euro.format(cent / 100);

    cta.disabled = true;
    svuotaPrenotazioni().then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: varianteId, quantity: 1, properties: props }] })
      });
    }).then(function (r) {
      if (!r || !r.ok) throw new Error('aggiunta non riuscita');
      window.location.href = '/checkout';
    }).catch(function () {
      cta.disabled = false;
      if (ris) ris.textContent = 'Non è riuscito l’invio. Riprova fra un momento.';
    });
  });

  aggiorna();
})();
